<template>
  <div>
    <template v-if="isCommon">
      <a-form-item :label="$t('common_516')" :extra="$t('common_504', [templateLabel])">
        <attribute-name-select
          v-decorator="decorators.user_id_attribute"
          :attribute-name-options="attributeNameOptions"
          :placeholder="$t('iam.idp.attribute_name.prompt', [templateLabel,$t('common_516'),templateLabel.toLocaleLowerCase(),'user_id'])" />
      </a-form-item>
      <a-form-item :label="$t('system.field.username')" :extra="$t('common_505', [templateLabel])">
        <attribute-name-select
          v-decorator="decorators.user_name_attribute"
          :attribute-name-options="attributeNameOptions"
          :placeholder="$t('iam.idp.attribute_name.prompt', [templateLabel,$t('system.field.username'),templateLabel.toLocaleLowerCase(),'user_name'])" />
      </a-form-item>
    </template>
    <a-form-item :label="$t('common_501')">
      <a-switch v-decorator="decorators.auto_create_user">{{$t('common_499')}}</a-switch>
      <template slot="extra">{{$t('common_513')}}<br />{{$t('common_514')}}</template>
    </a-form-item>
    <template v-if="fd.auto_create_user">
      <a-form-item :label="$t('common_503', [$t('dictionary.domain')])" :extra="$t('system.text_229', [$t('dictionary.domain')])">
        <base-select
          v-if="isAdmin"
          @update:resList="resTargetDomain"
          :disabled="!!fc.getFieldValue('project_domain')"
          v-decorator="decorators.target_domain"
          resource="domains"
          filterable
          version="v1"
          :select-props="{
            placeholder: $t('common_656')
          }" />
          <span v-else>
            {{projectDomain}}
          </span>
      </a-form-item>
      <a-collapse accordion v-if="showCollapse" v-bind="collapseProps" @change="onCollapseChange">
        <a-collapse-panel key="1" :header="$t('system.text_214')">
          <a-form-item class="mb-0" :label="$t('system.text_205', [$t('dictionary.project')])">
            <a-row :gutter="8">
              <a-col :span="10">
                <a-form-item :wrapperCol="{ span: 24 }" :extra="$t('common_506', [templateLabel,$t('dictionary.user'),$t('dictionary.project')])">
                  <base-select
                    v-decorator="decorators.default_project_id"
                    resource="projects"
                    version="v1"
                    :params="projectParams"
                    remote
                    :item.sync="project"
                    :remote-fn="q => ({ filter: `name.contains(${q})` })"
                    :select-props="{ placeholder: $t('rules.project') }"
                    @update:initLoaded="onProjectSelectLoaded" />
                </a-form-item>
              </a-col>
              <a-col :span="14" v-if="isCommon">
                <template v-if="showProjectInput">
                  <a-form-item :wrapperCol="{ span: 24 }" :extra="$t('common_520')">
                    <div class="d-flex align-items-center">
                      <div class="flex-fill mr-1">
                        <attribute-name-select
                          v-decorator="decorators.project_attribute"
                          :attribute-name-options="attributeNameOptions"
                          :placeholder="$t('iam.idp.attribute_name.prompt', [templateLabel,$t('dictionary.project'),templateLabel.toLocaleLowerCase(),'project'])" />
                      </div>
                      <a-tooltip placement="right">
                        <span slot="title">{{$t('common_517', [templateLabel])}}</span>
                        <icon type="question" />
                      </a-tooltip>
                      <a-button type="link" @click="showProjectInput = !showProjectInput">{{$t('common_518', [templateLabel, this.$t('dictionary.project')]) }}</a-button>
                    </div>
                    <a-checkbox v-decorator="decorators.auto_create_project">{{$t('common_519')}}</a-checkbox>
                  </a-form-item>
                </template>
                <template v-else>
                  <a-button type="link" @click="showProjectInput = true">{{$t('common_521', [templateLabel, this.$t('dictionary.project')]) }}</a-button>
                </template>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item class="mb-0" :label="$t('system.text_205', [$t('dictionary.role')])">
            <a-row :gutter="8">
              <a-col :span="10">
                <a-form-item :wrapperCol="{ span: 24 }" :extra="$t('common_508', [templateLabel,$t('dictionary.user'),$t('dictionary.role'),$t('dictionary.project')])">
                  <base-select
                    v-decorator="decorators.default_role_id"
                    resource="roles"
                    version="v1"
                    :params="roleParams"
                    remote
                    :mapper="roleMapper"
                    :remote-fn="q => ({ filter: `name.contains(${q})` })"
                    :select-props="{ placeholder: $t('rules.role') }"
                    @update:initLoaded="onRoleSelectLoaded" />
                </a-form-item>
              </a-col>
              <a-col :span="14" v-if="isCommon">
                <template v-if="showRoleInput">
                  <a-form-item :wrapperCol="{ span: 24 }">
                    <div class="d-flex align-items-center">
                      <div class="flex-fill mr-1">
                        <attribute-name-select
                          v-decorator="decorators.role_attribute"
                          :attribute-name-options="attributeNameOptions"
                          :placeholder="$t('iam.idp.attribute_name.prompt', [templateLabel,$t('dictionary.role'),templateLabel.toLocaleLowerCase(),'role'])" />
                      </div>
                      <a-tooltip placement="right">
                        <span slot="title">{{$t('common_522', [templateLabel])}}</span>
                        <icon type="question" />
                      </a-tooltip>
                      <a-button type="link" @click="showRoleInput = !showRoleInput">{{$t('common_518', [templateLabel, this.$t('dictionary.role')])}}</a-button>
                    </div>
                  </a-form-item>
                </template>
                <template v-else>
                  <a-button type="link" @click="showRoleInput = true">{{$t('common_521', [templateLabel, this.$t('dictionary.role')])}}</a-button>
                </template>
              </a-col>
            </a-row>
          </a-form-item>
          <template v-if="isCommon">
            <a-form-item :label="$t('scope.text_245')" :extra="$t('common_510', [templateLabel])">
              <attribute-name-select
                v-decorator="decorators.user_displayname_attribute"
                :attribute-name-options="attributeNameOptions"
                :placeholder="$t('iam.idp.attribute_name.prompt', [templateLabel,$t('scope.text_245'),templateLabel.toLocaleLowerCase(),'displayname'])" />
            </a-form-item>
            <a-form-item :label="$t('scope.text_553')" :extra="$t('common_511', [templateLabel])">
              <attribute-name-select
                v-decorator="decorators.user_email_attribute"
                :attribute-name-options="attributeNameOptions"
                :placeholder="$t('iam.idp.attribute_name.prompt', [templateLabel,$t('scope.text_553'),templateLabel.toLocaleLowerCase(),'email'])" />
            </a-form-item>
            <a-form-item :label="$t('scope.text_200')" :extra="$t('common_512', [templateLabel])">
              <attribute-name-select
                v-decorator="decorators.user_mobile_attribute"
                :attribute-name-options="attributeNameOptions"
                :placeholder="$t('iam.idp.attribute_name.prompt', [templateLabel,$t('scope.text_200'),templateLabel.toLocaleLowerCase(),'mobile'])" />
            </a-form-item>
          </template>
        </a-collapse-panel>
      </a-collapse>
    </template>
  </div>
</template>

<script>
import AttributeNameSelect from '../components/AttributeNameSelect'

export default {
  name: 'IDPEditAdvanced',
  components: {
    AttributeNameSelect,
  },
  props: {
    fd: {
      type: Object,
      required: true,
    },
    fc: {
      type: Object,
      required: true,
    },
    templateData: {
      type: Object,
      required: true,
    },
    offsetWrapperCol: {
      type: Object,
      required: true,
    },
    isCommon: {
      type: Boolean,
      required: true,
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    initValues: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isAdmin: this.$store.getters.isAdminMode,
      isDomain: this.$store.getters.isDomainMode,
      projectDomain: this.$store.getters.userInfo.projectDomain,
      projectDomainId: this.$store.getters.userInfo.projectDomainId,
      scope: this.$store.getters.scope,
      showProjectInput: !!(this.isUpdate && this.initValues.project_attribute),
      showRoleInput: !!(this.isUpdate && this.initValues.role_attribute),
      collapseActiveKey: this.isUpdate ? '1' : undefined,
      project: {},
      decorators: {
        auto_create_user: [
          'auto_create_user',
          {
            valuePropName: 'checked',
          },
        ],
        target_domain: [
          'target_domain',
        ],
        default_project_id: [
          'default_project_id',
        ],
        role_attribute: [
          'role_attribute',
        ],
        project_attribute: [
          'project_attribute',
        ],
        default_role_id: [
          'default_role_id',
        ],
        auto_create_project: [
          'auto_create_project',
          {
            valuePropName: 'checked',
          },
        ],
        user_displayname_attribute: [
          'user_displayname_attribute',
        ],
        user_email_attribute: [
          'user_email_attribute',
        ],
        user_mobile_attribute: [
          'user_mobile_attribute',
        ],
        user_id_attribute: [
          'user_id_attribute',
          {
            rules: [
              { required: true, message: this.$t('common_607') },
            ],
          },
        ],
        user_name_attribute: [
          'user_name_attribute',
          {
            rules: [
              { required: true, message: this.$t('common_608') },
            ],
          },
        ],
      },
      attributeNames: {},
    }
  },
  computed: {
    projectParams () {
      return {
        limit: 0,
        scope: this.scope,
        project_domains: this.fd.target_domain,
      }
    },
    roleParams () {
      return {
        limit: 0,
        scope: this.scope,
        project_domains: ['default', this.fd.target_domain],
      }
    },
    showCollapse () {
      // 编辑模式在开启自动创建用户后即展示高级设置，不依赖 target_domain 已回填
      if (this.isUpdate && this.fd.auto_create_user) return true
      return this.fd.target_domain || this.isDomain
    },
    collapseProps () {
      // 仅编辑模式受控展开，避免新建时 activeKey=undefined 导致无法展开
      if (this.isUpdate) {
        return { activeKey: this.collapseActiveKey }
      }
      return {}
    },
    templateKey () {
      return this.templateData.key
    },
    templateLabel () {
      return this.templateData.label || ''
    },
    attributeNameOptions () {
      const names = this.attributeNames
      return Object.keys(names).map(key => ({
        value: key,
        label: names[key] && names[key] !== key ? `${key} (${names[key]})` : key,
      }))
    },
  },
  watch: {
    initValues: {
      handler (val) {
        if (!this.isUpdate || !val || !Object.keys(val).length) return
        if (val.project_attribute) this.showProjectInput = true
        if (val.role_attribute) this.showRoleInput = true
        if (this.fd.auto_create_user) {
          this.collapseActiveKey = '1'
          this.$nextTick(() => this.applyInitValues())
        }
      },
      immediate: true,
      deep: true,
    },
    'fd.auto_create_user' (val) {
      if (!this.isUpdate || !val) return
      this.collapseActiveKey = '1'
      this.$nextTick(() => this.applyInitValues())
    },
    showCollapse (val) {
      if (!this.isUpdate || !val) return
      this.collapseActiveKey = '1'
      this.$nextTick(() => this.applyCollapseInitValues())
    },
    'fd.target_domain' (val, oldVal) {
      if (this.isUpdate) {
        // 编辑模式：target_domain 就绪后再回填依赖它的项目/角色字段
        if (val) {
          this.$nextTick(() => this.applyCollapseInitValues())
        }
        return
      }
      if (oldVal === undefined || oldVal === val) return
      this.fc.resetFields(['default_project_id', 'project_attribute'])
    },
    'fd.template': {
      async handler (val) {
        // 新建时按模板填充默认属性；编辑模式保留已有配置
        if (!this.isUpdate) {
          const attributeInitialValues = {
            cas: {
              user_id_attribute: 'cas:user',
              user_name_attribute: 'cas:user',
            },
            oidc: {
              user_id_attribute: 'name',
              user_name_attribute: 'name',
            },
            saml: {},
          }
          let initialValues = {
            user_id_attribute: undefined,
            user_name_attribute: undefined,
          }
          if (attributeInitialValues[val]) {
            initialValues = {
              ...initialValues,
              ...attributeInitialValues[val],
            }
          }
          await this.$nextTick()
          this.fc.setFieldsValue(initialValues)
        }
        this.fetchAttributeNames()
      },
      immediate: true,
    },
    'fd.driver' () {
      this.fetchAttributeNames()
    },
    'fd.project_attribute': {
      handler (val) {
        if (val) this.showProjectInput = true
      },
      immediate: true,
    },
    'fd.role_attribute': {
      handler (val) {
        if (val) this.showRoleInput = true
      },
      immediate: true,
    },
  },
  methods: {
    onCollapseChange (key) {
      this.collapseActiveKey = key
    },
    onProjectSelectLoaded (loaded) {
      if (!loaded || !this.isUpdate) return
      const values = this.pickInitValues(['default_project_id'])
      if (Object.keys(values).length) {
        this.fc.setFieldsValue(values)
      }
    },
    onRoleSelectLoaded (loaded) {
      if (!loaded || !this.isUpdate) return
      const values = this.pickInitValues(['default_role_id'])
      if (Object.keys(values).length) {
        this.fc.setFieldsValue(values)
      }
    },
    pickInitValues (keys) {
      const values = {}
      keys.forEach(key => {
        if (this.initValues[key] !== undefined && this.initValues[key] !== null && this.initValues[key] !== '') {
          values[key] = this.initValues[key]
        }
      })
      return values
    },
    applyInitValues () {
      if (!this.isUpdate || !this.initValues) return
      const values = this.pickInitValues([
        'target_domain',
        'auto_create_project',
        'user_id_attribute',
        'user_name_attribute',
        'user_displayname_attribute',
        'user_email_attribute',
        'user_mobile_attribute',
      ])
      if (Object.keys(values).length) {
        this.fc.setFieldsValue(values)
      }
      if (this.showCollapse) {
        this.applyCollapseInitValues()
      }
    },
    applyCollapseInitValues () {
      if (!this.isUpdate || !this.initValues) return
      if (this.initValues.project_attribute) this.showProjectInput = true
      if (this.initValues.role_attribute) this.showRoleInput = true
      this.$nextTick(() => {
        const values = this.pickInitValues([
          'default_project_id',
          'default_role_id',
          'project_attribute',
          'role_attribute',
          'auto_create_project',
          'user_displayname_attribute',
          'user_email_attribute',
          'user_mobile_attribute',
        ])
        if (Object.keys(values).length) {
          this.fc.setFieldsValue(values)
        }
      })
    },
    roleMapper (list) {
      if (list && list.length > 0) {
        return list.filter(row => {
          if (row.domain_id === 'default') {
            return row.is_public
          }
          return true
        })
      }
      return []
    },
    resTargetDomain (list) {
      if (this.isUpdate) {
        // 按 id 或 name 解析 target_domain，确保 base-select 能选中
        const expectedId = this.initValues.target_domain
        const expectedName = this.initValues.target_domain_name || this.initValues.target_domain
        const matched = (list || []).find(item => item.id === expectedId || item.name === expectedId || item.name === expectedName || item.id === expectedName)
        if (matched) {
          this.fc.setFieldsValue({ target_domain: matched.id })
          this.$nextTick(() => this.applyCollapseInitValues())
        }
        return
      }
      const project_domain = this.fc.getFieldValue('project_domain')
      if (!project_domain) return
      this.fc.setFieldsValue({
        target_domain: project_domain,
      })
    },
    async fetchAttributeNames () {
      if (!this.fd.driver || !this.fd.template) {
        this.attributeNames = {}
        return
      }
      const template = this.fd.template.toLowerCase()
      const params = {
        driver: this.fd.driver.toLowerCase(),
      }
      if (params.driver !== template) {
        params.template = template
      }
      try {
        const manager = new this.$Manager('identity_providers', 'v1')
        const { data } = await manager.get({
          id: 'attribute-names',
          params,
        })
        this.attributeNames = data || {}
      } catch (err) {
        this.attributeNames = {}
      }
    },
  },
}
</script>
